import { useQuery } from "@tanstack/react-query";

import { getReferralHistoryService } from "./service";

export function useReferralHistoryQuery(id?: number | string) {
  return useQuery({
    queryKey: ["v1/partner_referral_admin", String(id), "history"],
    queryFn: async () => getReferralHistoryService(id as number | string),
    enabled: Boolean(id),
  });
}
